import React from 'react';
import cx from 'classnames';
import { Asset, Button, CheckmarkIcon } from '@clearcover/atlas';

import { FeeStrategyCardProps } from './types';
import styles from './styles.module.css';

const generateDataTestId = (label: string) =>
  `fee-strategy-title-${label.toLowerCase().replace(/\s+/g, '-')}`;

export const FeeStrategyCard: React.FC<FeeStrategyCardProps> = ({
  children,
  title,
  selected,
  buttonLabel,
  loading,
  onSelectStrategy,
  ...props
}) => {
  return (
    <div
      className={cx(styles.strategyCardContainer, {
        [styles.selected]: selected,
      })}
      {...props}
    >
      <div className={styles.sectionHeader}>
        <h4 data-testid={generateDataTestId(title)}>{title}</h4>
      </div>
      <div className={styles.sectionContent}>{children}</div>
      <div className={styles.sectionFooter}>
        {selected ? (
          <Button
            variant="primary"
            block
            size="sm"
            data-testid="fee-strategy-selected-button"
            data-submitting={loading ? true : undefined}
            className={styles.selectedButton}
            isSubmitting={loading}
          >
            <span>
              <Asset
                icon={CheckmarkIcon}
                height={16}
                width={16}
                description="Checkmark icon"
              />
              {buttonLabel}
            </span>
          </Button>
        ) : (
          <Button
            variant="secondary"
            block
            size="sm"
            onClick={onSelectStrategy}
            data-testid="fee-strategy-select-button"
            disabled={loading}
          >
            {buttonLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
